import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WizumenModel } from '../../wizumen-models';

@Component({
  selector: 'wizumen-date-countdown',
  template: `
    <p *ngIf="item.time_to_trip_message" class="wizumen-date">
        <i class="eva-3-icon-calendar eva-icon {{this.iconSizeResolver()}}"></i>
        <em class="wizumen-date-text"> {{item.time_to_trip_message}}</em>
    </p>
  `,
  styleUrls: ['wizumen-date-countdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenDateCountdown {
  @Input() item: WizumenModel;
  @Input() isDesktop: boolean;

  public iconSizeResolver(): string {
    return this.isDesktop ? '-eva-3-icon-md' : '-eva-3-icon-xsm';
  }
}
